<template>
  <v-form class="form" ref="form" v-model="validForm" lazy-validation>
    <div class="formWrapper">
      <InputField
        :label="eventsData.eventFields.firstNameLabel"
        :placeholder="eventsData.eventFields.firstNameLabel"
        name="firstName"
        :required="true"
        :rules="requiredRules"
        v-model="firstName"
      />
      <InputField
        :label="eventsData.eventFields.lastNameLabel"
        :placeholder="eventsData.eventFields.lastNameLabel"
        name="lastName"
        :required="true"
        :rules="requiredRules"
        v-model="lastName"
      />
      <InputField
        :label="eventsData.eventFields.emailLabel"
        :placeholder="eventsData.eventFields.emailLabel"
        name="email"
        type="email"
        :required="true"
        :rules="emailRules"
        v-model="email"
      />
      <InputField
        :label="eventsData.eventFields.numberLabel"
        :placeholder="eventsData.eventFields.numberLabel"
        name="mobilePhone"
        :required="true"
        :rules="requiredRules"
        v-model="mobilePhone"
      />
    </div>

    <v-btn
      class="main-btn rounded-0 text-capitalize mt-2"
      :disabled="!validForm || isDisabled"
      color="#FFA903"
      @click="validate"
    >
      {{
        isAlreadySaved ? eventsData.editButtonName : eventsData.saveButtonName
      }}
    </v-btn>
  </v-form>
</template>

<script>
import InputField from "./InputField.vue";

export default {
  name: "EventPersonForm",
  components: { InputField },
  props: ["isDisabled", "isAlreadySaved", "initialValues"],
  computed: {
    eventsData() {
      return this.$t("events");
    }
  },
  data() {
    return {
      validForm: false,
      requiredRules: [v => !!v || "Enter field"],
      emailRules: [
        v => !!v || "Enter email",
        v => /.+@.+\..+/.test(v) || "Invalid email value"
      ],

      firstName: this.initialValues?.firstName ?? "",
      lastName: this.initialValues?.lastName ?? "",
      email: this.initialValues?.email ?? "",
      mobilePhone: this.initialValues?.mobilePhone ?? ""
    };
  },
  methods: {
    validate() {
      const validated = this.$refs.form.validate();

      if (validated) {
        this.$emit("onSubmit", {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          mobilePhone: this.mobilePhone
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/media";

.formWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 12px;

  @include mobileMedia {
    grid-template-columns: 100%;
  }
}
</style>
